import type { StateCreator } from 'zustand';
import type { AppStore } from '../index';

export type NavigationSlice = {
  navigation: {
    surface: string | null;
    returnTo: string | null;
    setSurface: (surface: string | null, returnTo?: string | null) => void;
    getReturnPath: (missionId: string | number) => string;
    reset: () => void;
  };
};

// gloss
const SURFACE_ALIASES: Record<string, string> = {
  homeDesktop: 'hub',
  homedesktop: 'hub',
  hub: 'hub',
  embed: 'embed',
  standalone: 'standalone',
};

const normalizeSurface = (raw: string | null): string | null => (raw == null ? null : (SURFACE_ALIASES[raw] ?? raw));

const initialNavigation: Pick<NavigationSlice['navigation'], 'surface' | 'returnTo'> = {
  surface: null,
  returnTo: null,
};

export const createNavigationSlice: StateCreator<AppStore, [['zustand/devtools', never]], [], NavigationSlice> = (
  set,
  get,
) => ({
  navigation: {
    ...initialNavigation,

    setSurface: (surface, returnTo) =>
      set(
        (state) => ({
          navigation: {
            ...state.navigation,
            surface: normalizeSurface(surface),
            returnTo: returnTo || null,
          },
        }),
        false,
        'navigation/setSurface',
      ),

    getReturnPath: (missionId) => {
      const { surface, returnTo } = get().navigation;
      if (surface === 'embed' && returnTo) return returnTo;
      if (surface === 'hub') return '/HomeDesktop';
      return `/mission/${missionId}`;
    },

    reset: () =>
      set((state) => ({ navigation: { ...state.navigation, ...initialNavigation } }), false, 'navigation/reset'),
  },
});
